import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground,
    NativeModules,
    FlatList,
    Text, I18nManager

} from "react-native"
import {moderateScale} from "./../tools/Scaling";
import * as Colors from "./../tools/Colors";
import i18n from "../I18n/i18n";

import PathFile from "../assets/PathFile";
import moment from "moment-jalaali";
import HMDialogSelectDate from "./HMDialogSelectDate";
import connect from "react-redux/es/connect/connect";
import HMTextView from "./HMTextView";
import HMIcon from "./HMIcon";
import store from "../redux/store";
import {serviceActionSetTimeSpan} from "../screens/satia/splash/action/ActionSplashSatiaScreen";

let container = null;

class HMSelectTimeFooter extends Component {

    constructor(props) {
        super(props);
        container = this;
        this.state = {
            openSelectDate: props.openSelectDate ? props.openSelectDate : false,
            showDialogDate: props.showDialogDate,
            arraySelected: props.arraySelected,
            DateFrom: props.DateFrom,
            DateTo: props.DateTo,
            month: props.month,
            indexSelectMonthType: props.indexSelectMonthType || props.indexSelectMonthType == 0 ? props.indexSelectMonthType : 1,
            // value: 'احمد' indexSelectMonthType || indexSelectMonthType == 0 ? indexSelectMonthType : 1
        }
    }


    componentWillReceiveProps(props) {


    }


    componentDidMount() {
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }


    render() {
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        let {_setStateData, func, text, styleRoot, style, type, cammas, lang, linkStyle, linkText, onPressLink, HyperlinkCheck, numberOfLines} = this.props;
        let {DateTo, DateFrom} = this.state;

        return (
            <View style={this.state.showDialogDate && this.state.typeDialogDate === "D" && this.state.openSelectDate ? {
                position: 'absolute', top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                zIndex: 99999,
                backgroundColor: 'rgba(0,0,0,0.7)',

            } : {width: "100%"}}>
                <View style={{width: "98%", alignSelf: "center", marginVertical: moderateScale(6),}}>
                    {
                        this.state.openSelectDate ?
                            <View style={{width: "100%"}}>
                                <View style={{padding: moderateScale(4)}}>
                                    <FlatList
                                        // style={{height: moderateScale(36)}}
                                        //    data={result.items}
                                        // data={this.props.ListFilter ? this.props.ListFilter : []}
                                        data={[
                                            {
                                                type: '1',
                                                image: PathFile.base64Image.Month1,
                                            },

                                            {
                                                type: '3',
                                                image: PathFile.base64Image.Month3,

                                            },
                                            {
                                                type: '6',
                                                image: PathFile.base64Image.Month6,

                                            },
                                            {
                                                type: 'D',
                                                image: PathFile.base64Image.SelectDate,
                                            },

                                            // {
                                            //
                                            //     type: '3',
                                            //     name: 'تاریخ',
                                            // },

                                        ]}
                                        //   numColumns={3}
                                        renderItem={({item, index}) => {

                                            //let checkIndex = this.checkSelect(item, index);
                                            // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar
                                            //  let idx = this.state.arraySelected.findIndex(obj => obj.index === index);
                                            //   let checkIndex = (idx !== -1);


                                            return <TouchableOpacity
                                                onPress={() => {
                                                    let endDate = this.state.DateTo;
                                                    let m = null;
                                                    let startDate = this.state.DateFrom;


                                                    if (item.type !== "D") {
                                                        endDate = moment().format('jYYYY/jM/jD');
                                                        m = moment(endDate, 'jYYYY/jM/jD');
                                                        startDate = m.subtract(item.type, 'month').locale('fa').format('jYYYY/jM/jD');
                                                        console.log("startDate@@", startDate)
                                                    }
                                                    console.log("startDate@@", startDate, endDate)
                                                    let obj = {
                                                        indexSelectMonthType: index,
                                                        type: item.id,
                                                        month: item.type,
                                                        showDialogDate: item.type === "D",
                                                        typeDialogDate: item.type,
                                                        DateFrom: startDate,
                                                        DateTo: endDate,
                                                    };
                                                    _setStateData(obj);
                                                    this.setState(obj,
                                                        () => {
                                                            if (item.type !== "D")
                                                                func ? func() : null
                                                        }
                                                    )

                                                }
                                                }
                                                style={{
                                                    width: moderateScale(70),
                                                    height: moderateScale(70),
                                                    // paddingHorizontal: moderateScale(3),
                                                    //      backgroundColor: "#ee00e9",
                                                    borderRadius: moderateScale(4),
                                                    borderWidth: moderateScale(1),
                                                    borderColor: this.state.indexSelectMonthType == index ? Colors.blackLight : Colors.transparent,
                                                    marginHorizontal: moderateScale(2),
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <View style={{
                                                    width: moderateScale(60),
                                                    height: moderateScale(60),
                                                    // backgroundColor: "#0fbbee",
                                                }}>
                                                    <Image resizeMode={'contain'} source={{
                                                        uri: 'data:image/png;base64,' + item.image,
                                                        //   uri:'data:image/png;base64,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',
                                                        scale: 1
                                                    }} style={{
                                                        width: "100%",
                                                        height: "100%",
                                                    }}/>

                                                </View>

                                            </TouchableOpacity>

                                        }}
                                        horizontal={true}
                                        showsHorizontalScrollIndicator={false}
                                        keyExtractor={(item, index) => index.toString()}
                                        inverted={Platform.OS === 'android' && i18n.locale == 'fa'}


                                    />

                                </View>
                                <View style={{
                                    width: '100%',
                                    height: moderateScale(1),
                                    alignSelf: 'center',
                                    backgroundColor: Colors.light43
                                }}/>
                            </View>
                            :
                            null
                    }

                    <View style={{width: "100%", flexDirection: "row"}}>
                        {
                            this.props.ListFilter ?
                                <View style={{width: "50%",}}>
                                    <FlatList
                                        // style={{height: moderateScale(36)}}
                                        //    data={result.items}
                                        data={this.props.ListFilter ? this.props.ListFilter : []}
                                        // data={[
                                        //     {
                                        //
                                        //         type: '1',
                                        //         name: 'وضعیت پیام',
                                        //
                                        //     },
                                        //     {
                                        //
                                        //         type: '2',
                                        //         name: 'واحد اجرایی',
                                        //     },
                                        //
                                        //     // {
                                        //     //
                                        //     //     type: '3',
                                        //     //     name: 'تاریخ',
                                        //     // },
                                        //
                                        // ]}
                                        //   numColumns={3}
                                        renderItem={this.renderItemFilter}
                                        //  horizontal={true}
                                        showsHorizontalScrollIndicator={false}
                                        keyExtractor={(item, index) => index.toString()}
                                        //inverted={Platform.OS === 'android' && i18n.locale == 'fa'}


                                    />
                                </View>
                                : null
                        }

                        <View style={{
                            width: this.props.ListFilter ? "50%" : "100%",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <TouchableOpacity
                                style={{flexDirection: "row"}}
                                onPress={() => {
                                    this.setState({

                                            showDialogDate: true,
                                            openSelectDate: !this.state.openSelectDate,

                                            typeDialogDate: null,
                                        },
                                        () => {
                                        }
                                    )
                                }}
                            >
                                <HMTextView
                                    text={(this.props.DateTo || this.props.DateFrom ? this.props.DateFrom + " لغایت " + this.props.DateTo : "")}
                                    type={"bold"}
                                    style={{
                                        marginHorizontal: moderateScale(6),
                                        fontSize: moderateScale(14),
                                        color: Colors.blue,
                                        textDecorationLine: "underline",
                                        textDecorationStyle: "solid",

                                    }}/>

                                <HMIcon
                                    //type={"Feather"}
                                    name={this.state.openSelectDate ? "chevron-up" : "chevron-down"}
                                    style={{
                                        color: Colors.blue,
                                        fontSize: moderateScale(18),
                                        //  padding: moderateScale(4),
                                        alignSelf: "center",
                                    }}/>


                            </TouchableOpacity>
                        </View>

                    </View>


                </View>
                {
                    this.state.showDialogDate && this.state.typeDialogDate === "D" && this.state.openSelectDate ?
                        <HMDialogSelectDate
                            DateTo={DateTo}
                            DateFrom={DateFrom}
                            onPressOk={this.setDate}
                            onPressCancel={() => {
                                this.setState({
                                    showDialogDate: false
                                })
                            }}

                        />

                        :

                        null
                }

            </View>

        );
    }

    setDate(DateFrom, DateTo) {
        let {_setStateData, func} = container.props;

        let obj = {
            DateFrom, DateTo, showDialogDate: false,
            indexSelectMonthType: container.state.indexSelectMonthType,
        };
        store.dispatch(serviceActionSetTimeSpan(DateFrom, DateTo, 3, null));
        _setStateData(obj);
        container.setState(obj,
            () => {
                func ? func() : null
            }
        )
    }

}


const mapStateToProps = state => {
    return {
        //  DataSplashScreen: state.reducerSplashSatiaScreen,
        //  wifiIsEnabled: state.reducerSplashSatiaScreen.wifiIsEnabled,
        // wifiConnectionStatus: state.reducerSplashSatiaScreen.wifiConnectionStatus,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        // setIsConnected: (data) => dispatch(serviceActionSetIsConnected(data)),
        // callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(HMSelectTimeFooter);
